import { Badge } from "@workspace/ui/components/badge";
import { FormattedPrice } from "@workspace/ui/components/formatted-price";
import { cn } from "@workspace/ui/lib/utils";
import { Link } from "react-router";

interface VariantSelectorProps {
	variants: Array<{
		id: string;
		sku: string;
		name: string;
		description: string;
		defaultPrice?: number | null;
		defaultPriceForEveryone?: number | null;
		path: string;
	}>;
	selectedVariant: {
		sku: string;
	};
}

export function VariantSelector({
	variants,
	selectedVariant,
}: VariantSelectorProps) {
	return (
		<>
			{variants.length > 1 &&
				variants.map((variant) => (
					<Link
						replace
						key={variant.sku}
						to={`?variant=${variant.sku}`}
						prefetch="intent"
						preventScrollReset
						className={cn(
							"flex cursor-pointer items-center justify-between rounded-lg border-2 p-4 transition-colors",
							selectedVariant.sku === variant.sku
								? "border-primary bg-primary/5"
								: "border-border hover:border-primary/50",
						)}
					>
						<div className="mr-4 grow">
							<div id={`${variant.id}-title`} className="font-medium">
								{variant.name}
							</div>
							<div
								id={`${variant.id}-description`}
								className="text-muted-foreground text-sm"
							>
								{variant.description}
							</div>
						</div>
						<div className="flex min-w-[80px] flex-col items-end">
							{variant.defaultPrice != null &&
								variant.defaultPriceForEveryone != null &&
								variant.defaultPrice !== variant.defaultPriceForEveryone && (
									<div className="flex items-center gap-1">
										<FormattedPrice
											price={variant.defaultPrice}
											variant="discount"
											className="text-muted-foreground text-sm"
										/>
										<Badge variant="destructive" className="text-xs">
											-{Math.round((1 - variant.defaultPriceForEveryone / variant.defaultPrice) * 100)}%
										</Badge>
									</div>
								)}
							<div id={`${variant.id}-price`} className="font-medium">
								<FormattedPrice
									price={variant.defaultPriceForEveryone}
									className="font-bold text-lg"
								/>
							</div>
						</div>
					</Link>
				))}
		</>
	);
}
